import React from 'react';
import { useTranslation } from 'react-i18next';
import LoadingCircle from 'components/ui/LoadingCircle';
import { Document } from './Document';
export function DocumentsList({ isOrder, documents, deleteDisabled, onDeleteConfirm, onDeleteDecline, sentDocuments, loading, }) {
    const { t } = useTranslation();
    const entity = isOrder ? 'order' : 'shipment';
    if (loading) {
        return React.createElement(LoadingCircle, { text: t('LOADING') });
    }
    if (!documents || documents.length === 0) {
        return React.createElement("i", null, t('THIS_ENTITY_HAS_NO_DOCUMENTS', { entity }));
    }
    return (React.createElement("div", { className: "overflow-x-auto" },
        React.createElement("table", { "data-testid": "shipment-documents-table", className: "default-table" },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", null, t('DOCUMENT')),
                    React.createElement("th", null, t('DATE_one')),
                    React.createElement("th", null, t('SIGNATORY')),
                    React.createElement("th", null, t('STATUS')),
                    React.createElement("th", null, t('USER')),
                    React.createElement("th", null, "\u00A0"))),
            React.createElement("tbody", null, documents.map((document, index) => (React.createElement(Document, { key: document.id || index, isOrder: isOrder, document: document, deleteDisabled: deleteDisabled, onDeleteConfirm: onDeleteConfirm, onDeleteDecline: onDeleteDecline, isSent: Boolean(sentDocuments.find((doc) => doc.id === document.id)) })))))));
}
